import router from '@/router'
import store from '@/store'
import { addToRouteHistory, getIsGoingBack, setRouteSource } from '@/utils/common'

const ROUTE_SOURCE_TRACKING_NAMES = ['powerStationInfo']

// permissiom judge function
// eslint-disable-next-line no-unused-vars
function hasPermission(roles, permissionRoles) {
  if (roles.indexOf('admin') >= 0) return true // admin permission passed directly
  if (!permissionRoles) return true
  return roles.some(role => permissionRoles.indexOf(role) >= 0)
}

// 判断权限[1,2,3,4,66,33,88]和[99,0,56,3]的包含关系
// eslint-disable-next-line no-unused-vars
const whiteList = ['/login']// no redirect whitelist

// function authentication(menuIds, meta) {
//   let flag = false
//   if (meta?.menuId) {
//     if (menuIds.indexOf(meta.menuId) != -1) {
//       flag = true
//     } else {
//       flag = false
//     }
//   } else {
//     flag = true
//   }
//   return flag
// }
router.beforeEach((to, from, next) => {
  const goingBack = getIsGoingBack()
  addToRouteHistory(from)
  if (ROUTE_SOURCE_TRACKING_NAMES.includes(to.name) && !goingBack) {
    setRouteSource(to.name, from)
  }
  // 修复已登录情况下，直接访问域名，会跳转到登录页的问题
  if (window.localStorage.getItem("newToken") && to.path === '/login') {
    next({ path: '/home' })
    return
  }
  // 当用户不在登录页面时，关闭所有 cookie 相关弹窗
  if (to.path !== '/login') {
    store.dispatch('cookie/closeAllCookieModals')
  }
  // let userInfo = store.getters["userInfo"]
  const menuIds = store.getters.menuIds
  if (to.path === '/login' || to.path=='/userAgreement' || to.path=='/privacyPolicy' || to.path=='/Register' || to.path=='/RegisterAccomplish') {
    next()
  } else {
    // if (!menuIds?.length) {
    //   next({ path: '/login' })
    // }
    // if (authentication(menuIds, to.meta)) {
      // 如果字典未获取过则请求一次
      if (!store.state.dict.dictRequested) {
        store.dispatch('setDict')
      }
      const permissiomList = store.state.user.permissions
      if (Array.isArray(permissiomList) && permissiomList.length === 0) {
        // 判断当前用户是否已拉取完user_info信息
        store.dispatch('GetInfo').then((accessRoutes) => {
          // 根据roles权限生成可访问的路由表
          const newArr = accessRoutes.filter(item => item.path)
          newArr.forEach(item => {
            router.addRoute(item);
          })
          next({ ...to, replace: true }) // hack方法 确保addRoutes已完成
        }).catch(err => {
          console.log('err', err)
          next({ path: '/' })
        })
      } else {
        next()
      }
    //   next()
    // } else {
    //   next({ path: '/404' })
    // }
  }
})

// router.afterEach(() => {
// })